import VueI18n from 'vue-i18n';
import pm from './payment_methods';
import elementUI from './elementUI';
import { messages as multiInvoicePageTranslations } from '@/pages/FlowInvoice/MultiInvoicePage/translations/index.js';
import { messages as kunaPageTranslations } from '@/pages/FlowInvoice/KunaPage/translations/index.js';
import { messages as muchBetterTranslations } from '@/pages/FlowInvoice/MuchbetterPage/translations/index.js';
import { messages as paywiseTranslations } from '@/pages/FlowInvoice/PaywisePage/translations/index.js';
import { messages as crptTranslations } from '@/pages/FlowInvoice/CrptPage/translations/index.js';
import { messages as selcomTranslations } from '@/pages/FlowInvoice/SelcomPage/translations/index.js';
import mifinityMessages from '@/pages/FlowInvoice/MifinityPage/translations/index.js';
import spushMessages from '@/pages/FlowInvoice/SpushPage/translations/index.js';
import rapipagoMessages from '@/pages/FlowInvoice/RapipagoPage/translations/index.js';
import klashaMessages from '@/pages/FlowInvoice/KlashaPage/translations/index.js';

const messages = {
  ru: {
    home: 'К выбору метода',
    more_categories: 'Больше категорий',
    search: 'Поиск',
    loading: 'Загрузка',
    not_working: 'Не работает',
    error_validation: 'Исправьте параметры и попробуйте снова:',
    error_signature: 'Подпись данных неверна',
    amount: 'Сумма',
    terms_of_use: 'Пользовательское соглашение',
    support: 'Поддержка',
    powered_by: 'Powered by',
    enter_details: 'Введите ваши данные',
    first_name: 'Имя',
    last_name: 'Фамилия',
    full_name: 'Полное имя',
    email: 'E-mail',
    phone_number: 'Номер телефона',
    next: 'Далее',
    cancel: 'Отменить',
    page_not_found: 'Такой страницы оплаты не существует',
    try_to_return: 'Попробуйте вернуться в магазин и начать сначала',
    request_expired: 'Срок действия платежного запроса закончился',
    now_redirect_to_pg: 'Сейчас вы будете перенаправлены на платёжный шлюз',
    payment_details: 'Детали оплаты',
    operation_number: '№ операции',
    payment_date: 'Дата оплаты',
    return_to_shop: 'Вернуться',
    shipping_details: 'Данные по доставке',
    address: 'Адрес',
    city: 'Город',
    index: 'Почтовый индекс',
    select_country: 'Выберите страну',
    processing_test_payment: 'Вы производите тестовую оплату',
    processing_test_payment_desc:
      'Тестовая оплата предназначена для проверки правильность настроек шлюза.',
    processing_test_payment_second_desc:
      'При тестовой оплате с вас не будут списаны никакие средства.',
    process_test_payment: 'Провести успешную оплату',
    chose_preferred_currency: 'Выберите предпочитаемую валюту.',
    pay: 'Оплатить',
    your_account_number: 'Ваш номер счёта:',
    give_blank_to_manager: 'Передайте работнику банка заполненый бланк',
    find_nearest_bank: 'Найдите ближайшее отделение банка',
    deposit_the_amount: 'Внесите в кассу необходимую сумму и комиссию.',
    when_payment_will_process:
      'Когда платёж начнёт обрабатываться, вам придёт уведомление на ваш телефон.',
    check_status: 'Проверить статус',
    say_to_manager:
      'Скажите сотруднику банка, что вам необходимо провести платёж со свободными реквизитами:',
    payer: 'Плательщик',
    edrpou: 'ЕДРПОУ',
    checking_account: 'Р/С',
    bank: 'Банк',
    mfo: 'МФО',
    purpose_of_payment: 'Назначение платежа',
    payment_pay: 'Оплата счёта',
    print_requisites: 'Распечатать реквизиты',
    full_name_example: 'Например, Валентин Петровский',
    dont_want_pay: 'Передумали платить?',
    tell_us_about_it: 'Подскажите нам, что вам помешало успешно провести процесс оплаты:',
    dont_want: 'Передумал платить',
    no_trust: 'Нет доверия',
    complex_payment_process: 'Сложный процесс оплаты',
    incorrect_payment_details: 'Некорректные данные оплаты',
    come_back: 'Вернуться назад',
    feedback: 'Отзыв',
    only_local_payment_ways: 'Только локальные способы оплаты',
    all_payment_ways:
      'Включите эту опцию, чтобы отобразить все доступные способы, независимо от вашего местоположения',
    '400_checkout_inactive': 'Платёжная страница не активна',
    '400_no_methods': 'Нет ни одного платёжного метода',
    '400_no_payment_request': 'Платёжный запрос не существует',

    'purpose-of-payment': 'Назначение платежа',
    remains: 'До конца оплаты',

    'select-language': 'Выберите язык',
    close: 'Закрыть',
    buy: 'Купить',
    donate: 'Пожертвовать',
    deposit: 'Внести средства',
    'please-input': 'Введите запрос',

    // Categories
    all: 'Все',
    alternative: 'Альтернативные',
    bank_cards: 'Банковские карты',
    bank_card: 'Банковские карты',
    e_wallets: 'Электронные кошельки',
    'e-Wallets': 'Электронные кошельки',
    internet_banking: 'Интернет банкинг',
    liqpay_wallet: 'Liqpay кошелек',
    privatbank_ssk: 'Приватбанк терминал',
    cash: 'Наличные',

    'internal-server-error': 'Ошибка сервера',
    'hide-details': 'Скрыть подробности',
    'show-details': 'Показать подробности',

    other: 'Еще',
    payment_card: 'Платежная карта',
    bank_transfer: 'Банковский перевод',
    cash_on_delivery: 'Наложенный платёж',
    cash_payment: 'Наличный расчет',
    check: 'Чек',
    direct_debit: 'Прямое дебетование',
    digital_wallet: 'Электронный кошелёк',
    prepaid_voucher: 'Предоплаченный ваучер',
    prepaid_card: 'Предоплаченная карта',
    invoice_payment: 'Выставление счета',
    mobile_carrier_billing: 'Биллинг мобильного оператора',
    mobile_payment: 'Мобильный платеж',
    'public-services': 'Комунальные платежи',
    others: 'Другие услуги',
    telecommunications: 'Телекомуникации',
    'financial-services': 'Финансовые услуги',
    taxi: 'Такси',
    charity: 'Благотворительность',
    entertainment: 'Развлечения',
    'budget-payments': 'Платежи в бюджет',
    distribution: 'Дистрибуция',
    'selling-goods': 'Продажа товаров',
    step: 'Шаг {step} из {steCnt}',

    success: 'Платёж отправлен',
    error: 'Ошибка оплаты',
    canceled: 'Платёж отменен',
    pending: 'Платёж в обработке',
    processed: 'Платёж отправлен',

    phone: 'Номер телефона',
    'amount-should-be':
      'Сумма платежа не должна быть ниже {min} {currency} и выше {max} {currency}',
    no_payment_request: 'Платёжный запрос отсутствует',
    'no-results': 'Результаты не найдены',
    cancel_test_payment: 'Провести неуспешную оплату',
    routes_empty: 'Нет доступных маршрутов',
    stepper__first__select_method: 'Выбор способа оплаты',
    stepper__second__payment_process: 'Оплата',
    stepper__third__status_page: 'Статус оплаты',

    direct_call_forwarding: 'Перенаправление',
    direct_call_forwarding_description: 'Вы будете перенаправлены на страницу оплаты',
    empty_data: 'Нет данных',
    common__search_placeholder: 'Поиск по методам',

    process_failed: 'Ошибка оплаты',

    step__service_select: 'Выбор метода оплаты',
    step__payment_process: 'Процесс оплаты',
    step__payment_result: 'Результат',

    commerce_account: 'Ошибка коммерческого аккаунта',

    //Selcom

    common__invoice: 'Инвойс',
    common__cardholder: 'Держатель карты',
    common__expiry: 'Срок действия',
    common__amount_to_pay: 'Сумма к оплате',

    invoice_receipt_number: 'Номер квитанции инвойса',
    message: 'Сообщение',
    upi_transaction_id: 'ID транзакции UPI',
    bank_transaction_id: 'ID транзакции банка',
    receipt: 'Квитанция',
    description: 'Описание',
    common__uploader_text: 'Перетащите файл сюда или <em>нажмите, чтобы загрузить</em>',
    common__files: 'файлы',
    common__files_size_kb: '{size} кБ',
    common__files_size_mb: '{size} мБ',

    ...mifinityMessages.ru,
    ...multiInvoicePageTranslations.ru,
    ...kunaPageTranslations.ru,
    ...muchBetterTranslations.ru,
    ...muchBetterTranslations.ru,
    ...crptTranslations.ru,
    ...selcomTranslations.ru,
    ...pm.ru,
    ...elementUI.ru,
  },
  uk: {
    home: 'До вибору методу',
    more_categories: 'Більше категорій',
    search: 'Пошук',
    loading: 'Завантаження',
    not_working: 'Не працює',
    error_validation: 'Виправте параметри та спробуйте знову',
    error_signature: 'Підпис даних невірний',
    amount: 'Сума',
    terms_of_use: 'Угода користувача',
    support: 'Підтримка',
    powered_by: 'Powered by',
    enter_details: 'Введіть ваші дані',
    first_name: "Ім'я",
    last_name: 'Прізвище',
    full_name: "Повне ім'я",
    email: 'E-mail',
    phone_number: 'Номер телефону',
    next: 'Далі',
    cancel: 'Скасувати',
    page_not_found: 'Такої сторінки оплати не існує',
    try_to_return: 'Спробуйте повернутися до магазину і почати спочатку',
    request_expired: 'Термін дії платіжного запиту закінчився',
    now_redirect_to_pg: 'Зараз вас буде перенаправлено на платіжний шлюз',
    payment_details: 'Деталі оплати',
    operation_number: '№ операціі',
    payment_date: 'Дата оплати',
    return_to_shop: 'Повернутися',
    shipping_details: 'Дані з доставки',
    address: 'Адреса',
    city: 'Місто',
    index: 'Поштовий індекс',
    select_country: 'Оберіть країну',
    processing_test_payment: 'Ви проводите тестову оплату',
    processing_test_payment_desc:
      'Тестова оплата призначена для перевірки правильності налаштувань шлюзу.',
    processing_test_payment_second_desc: 'При тестової оплаті з вас не будуть списані кошти.',
    process_test_payment: 'Провести успішну оплату',
    cancel_test_payment: 'Провести неуспішну оплату',
    chose_preferred_currency: 'Виберіть бажану валюту.',
    pay: 'Оплатити',
    your_account_number: 'Ваш номер рахунку:',
    give_blank_to_manager: 'Передайте працівнику банку заповнений бланк',
    find_nearest_bank: 'Знайдіть найближче відділення банку',
    deposit_the_amount: 'Внесіть в касу необхідну суму і комісію.',
    when_payment_will_process:
      'Коли платіж почне оброблятися, вам прийде повідомлення на ваш телефон.',
    check_status: 'Перевірити статус',
    say_to_manager:
      'Скажіть робітнику банку, що вам необхідно провести платіж з вільними реквізитами:',
    payer: 'Платник',
    edrpou: 'ЕДРПОУ',
    checking_account: 'Р/Р',
    bank: 'Банк',
    mfo: 'МФО',
    purpose_of_payment: 'Призначення платежу',
    payment_pay: 'Оплата рахунку',
    print_requisites: 'Распечатать реквизиты',
    full_name_example: 'Наприклад, Петро Петрович',
    dont_want_pay: 'Передумали платити?',
    tell_us_about_it: 'Підкажіть нам, що вам завадило успішно провести процес оплати:',
    dont_want: 'Передумав платити',
    no_trust: 'Нема довіри',
    complex_payment_process: 'Складний процес оплати',
    incorrect_payment_details: 'Некоректні дані оплати',
    come_back: 'Повернутися назад',
    only_local_payment_ways: 'Тільки локальні способи оплати',
    feedback: 'Відгук',
    all_payment_ways:
      'Увімкніть цю опцію, щоб відобразити всі доступні способи, незалежно від вашого місця знаходження',

    '400_checkout_inactive': 'Платіжна сторінка не активна',
    '400_no_methods': 'Немає жодного платіжного методу',
    '400_no_payment_request': 'Платіжний запит не існує',

    'purpose-of-payment': 'Призначення платежу',
    remains: 'До кінця оплати',

    'select-language': 'Виберіть мову',
    close: 'Закрити',
    buy: 'Купити',
    donate: 'Пожертвувати',
    deposit: 'Внести кошти',
    'please-input': 'Введіть запит',

    all: 'Всі',
    alternative: 'Альтернативні',
    bank_cards: 'Банківські карти',
    e_wallets: 'Електронні гаманці',
    internet_banking: 'Інтернет банкінг',
    'e-Wallets': 'Електронні гаманці',
    liqpay_wallet: 'Liqpay гаманець',
    bank_card: 'Банківська карта',
    cash: 'Готівка',
    privatbank_ssk: 'приватбанк термінал',
    payment_card: 'Платіжна карта',
    bank_transfer: 'Банківський переказ',
    cash_on_delivery: 'Накладний платіж',
    cash_payment: 'Готівковий розрахунок',
    check: 'Чек',
    direct_debit: 'Пряме дебетування',
    digital_wallet: 'Електронний гаманець',
    prepaid_voucher: 'Передплачений ваучер',
    prepaid_card: 'Передплачена карта',
    invoice_payment: 'Виставлення рахунку',
    mobile_carrier_billing: 'Біллінг мобільного оператора',
    mobile_payment: 'Мобільний платіж',
    'public-services': 'Комунальні платежі',
    others: 'Інші послуги',
    telecommunications: 'Телекомунікації',
    'financial-services': 'Фінансові послуги',
    taxi: 'Таксі',
    charity: 'Благодійність',
    entertainment: 'Розваги',
    'budget-payments': 'Платежі до бюджету',
    distribution: 'Дистрибуція',
    'selling-goods': 'Продаж товарів',

    'internal-server-error': 'Помилка сервера',
    'hide-details': 'Сховати деталі',
    'show-details': 'Показати деталі',

    other: 'Ще',

    success: 'Платіж відправлено',
    error: 'Помилка оплати',
    canceled: 'Платіж відхилено',
    pending: 'Платіж в обробці',
    processed: 'Платіж відправлено',

    phone: 'Номер телефону',
    'amount-should-be':
      'Сума платежу не повинна бути нижчою {min} {currency} та вищою {max} {currency}',
    no_payment_request: 'Платіжний запит відсутній',
    'no-results': 'Результати не знайдені',
    routes_empty: 'Немає доступних маршрутів',
    stepper__first__select_method: 'Вибір способу оплати',
    stepper__second__payment_process: 'Оплата',
    stepper__third__status_page: 'Статус оплати',

    direct_call_forwarding: 'Перенаправлення',
    direct_call_forwarding_description: 'Вас буде перенаправлено на сторінку оплати',
    empty_data: 'Немає даних',
    common__search_placeholder: 'Пошук по методам',

    process_failed: 'Помилка оплати',

    step__service_select: 'Вибір методу оплати',
    step__payment_process: 'Процес оплати',
    step__payment_result: 'Статус вашого платежу',

    step: 'Крок {step} з {steCnt}',

    commerce_account: 'Помилка комерційного аккаунту',

    common__invoice: 'Інвойс',
    common__cardholder: "Ім'я власника",
    common__expiry: 'Термін дії',
    common__amount_to_pay: 'Сума до сплати',

    invoice_receipt_number: 'Номер квитанції інвойса',
    message: 'Повідомлення',
    upi_transaction_id: 'ID транзакції UPI',
    bank_transaction_id: 'ID транзакції банку',
    receipt: 'Квитанція',
    description: 'Опис',
    common__uploader_text: 'Перетягніть файл сюди або <em>натисніть, щоб завантажити</em>',
    common__files: 'файли',
    common__files_size_kb: '{size} кБ',
    common__files_size_mb: '{size} мБ',

    ...mifinityMessages.uk,
    ...multiInvoicePageTranslations.uk,
    ...kunaPageTranslations.uk,
    ...muchBetterTranslations.uk,
    ...selcomTranslations.uk,
    ...pm.uk,
    ...elementUI.uk,
  },
  en: {
    home: 'To method select',
    more_categories: 'More categories',
    search: 'Search',
    loading: 'Loading',
    not_working: 'Not working',
    error_validation: 'Check data and try again',
    error_signature: 'Data signature is invalid',
    amount: 'Amount',
    terms_of_use: 'Terms of use',
    support: 'Support',
    powered_by: 'Powered by',
    enter_details: 'Enter details',
    first_name: 'First name',
    last_name: 'Last name',
    full_name: 'Full name',
    email: 'E-mail',
    phone_number: 'Phone number',
    next: 'Next',
    common__cancel: 'Cancel',
    page_not_found: 'Page not found',
    try_to_return: 'Try to return to shop and try again',
    request_expired: 'Payment request expired',
    created_with_sketh: 'Created with Sketch.',
    now_redirect_to_pg: 'Now you will be redirected to the payment gateway',
    payment_details: 'Payment details',
    operation_number: 'Operation number',
    payment_date: 'Payment date',
    return_to_shop: 'Back',
    shipping_details: 'Delievery details',
    address: 'Address',
    city: 'City',
    index: 'Postcode',
    select_country: 'Select country',
    processing_test_payment: 'You make a test payment',
    processing_test_payment_desc:
      'The test payment is intended to verify the correctness of the gateway settings.',
    processing_test_payment_second_desc: 'With a test payment, you will not be charged any funds.',
    process_test_payment: 'Process successful payment',
    cancel_test_payment: 'Process failed payment',
    chose_preferred_currency: 'Choose your preferred currency.',
    pay: 'Pay',
    your_account_number: 'Your account number:',
    give_blank_to_manager: 'Give the bank employee a completed form',
    find_nearest_bank: 'Find the nearest bank',
    deposit_the_amount: 'Deposit the required amount and commission to the cashier.',
    when_payment_will_process:
      'When the payment starts to be processed, you will receive a notification to your phone.',
    check_status: 'Check status',
    say_to_manager: 'Tell the bank employee that you need to pay with free requisites:',
    payer: 'Payer',
    edrpou: 'EDRPOU',
    checking_account: 'C/A',
    bank: 'Bank',
    mfo: 'MFO',
    purpose_of_payment: 'Purpose of payment',
    payment_pay: 'Payment of the bill',
    print_requisites: 'Print requisites',
    full_name_example: 'For example, Sarah Kerrigan',
    dont_want_pay: 'Have you changed your mind about paying?',
    tell_us_about_it:
      'Tell us what prevented you from successfully completing the payment process:',
    dont_want: 'I changed my mind about paying',
    no_trust: 'No trust',
    complex_payment_process: 'Complex payment process',
    incorrect_payment_details: 'Incorrect payment data',
    come_back: 'Go back',
    only_local_payment_ways: 'Local payment ways only',
    feedback: 'Feedback',
    all_payment_ways:
      'Enable this option to display all available methods, regardless of your location',

    '400_no_methods': 'No payment methods',
    '400_checkout_inactive': 'Payment page is not active',
    '400_no_payment_request': 'Payment request does not exist',

    in_english: 'In English',
    in_ukrainian: 'Українською',
    in_russian: 'На русском',
    in_swahili: 'Swahili',
    in_french: 'En français',

    'purpose-of-payment': 'Purpose of payment',
    remains: 'Remains',

    'select-language': 'Select language',
    close: 'Close',
    buy: 'Buy',
    donate: 'Donate',
    deposit: 'Deposit',
    'please-input': 'Start typing...',

    all: 'All',
    alternative: 'Alternative',
    bank_cards: 'Bank cards',
    bank_card: 'Bank cards',
    e_wallets: 'eWallets',
    internet_banking: 'Internet banking',
    'e-Wallets': 'eWallets',
    liqpay_wallet: 'Liqpay wallet',
    cash: 'Cash',
    privatbank_ssk: 'Privatbank terminals',
    payment_card: 'Payment card',
    bank_transfer: 'Bank transfer',
    cash_on_delivery: 'Cash on delivery',
    cash_payment: 'Cash payment',
    check: 'Check',
    direct_debit: 'Direct debit',
    digital_wallet: 'Digital wallet',
    prepaid_voucher: 'Prepaid voucher',
    prepaid_card: 'Prepaid card',
    invoice_payment: 'Invoice payment',
    mobile_carrier_billing: 'Mobile carrier billing',
    mobile_payment: 'Mobile payment',
    'public-services': 'Utility payments',
    others: 'Other services',
    telecommunications: 'Telecommunications',
    'financial-services': 'Financial Services',
    taxi: 'Taxi',
    charity: 'Charity',
    entertainment: 'Entertainment',
    'budget-payments': 'Budget Payments',
    distribution: 'Distribution',
    'selling-goods': 'Selling goods',

    'internal-server-error': 'Internal server error',
    'hide-details': 'Hide details',
    'show-details': 'Show details',

    other: 'Other',

    success: 'Success',
    error: 'Error',
    canceled: 'Canceled',
    pending: 'Pending',
    processed: 'Processed',

    phone: 'Phone number',
    'amount-should-be': 'Payment amount should be between {min} {currency} and {max} {currency}',
    no_payment_request: 'No payment request',
    'no-results': 'No results found',
    routes_empty: 'No available routes',
    stepper__first__select_method: 'Select your payment method',
    stepper__second__payment_process: 'Payment process',
    stepper__third__status_page: 'Payment status',

    direct_call_forwarding: 'Redirecting',
    direct_call_forwarding_description: 'You will be redirected to the payment page',
    empty_data: 'No data',

    common__search_placeholder: 'Search in methods',

    process_failed: 'Payment failed',

    step__service_select: 'Payment method select',
    step__payment_process: 'Payment in process',
    step__payment_result: 'Payment result',

    step: 'Step {step} of {steCnt}',

    commerce_account: 'Commerce account error',

    new_deposit_instructions: 'New instruction how to deposit!',

    common__invoice: 'Invoice',
    common__cardholder: 'Card Holder',
    common__expiry: 'Expires',
    common__amount_to_pay: 'Amount to pay',

    invoice_receipt_number: 'Invoice Receipt number',
    message: 'Message',
    upi_transaction_id: 'UPI transaction ID',
    bank_transaction_id: 'Bank transaction ID',
    receipt: 'Receipt',
    description: 'Description',

    common__uploader_text: 'Drop file here or <em>click to upload</em>',
    common__files: 'files',
    common__files_size_kb: '{size} kB',
    common__files_size_mb: '{size} mB',

    ...spushMessages.en,
    ...mifinityMessages.en,
    ...multiInvoicePageTranslations.en,
    ...kunaPageTranslations.en,
    ...crptTranslations.en,
    ...muchBetterTranslations.en,
    ...paywiseTranslations.en,
    ...selcomTranslations.en,
    ...rapipagoMessages.en,
    ...klashaMessages.en,
    ...pm.en,
    ...elementUI.en,
  },

  pt: {
    payment_details: 'Detalhes do pagamento',
    operation_number: 'Número da Operação',
    payment_date: 'Data de pagamento',
    amount: 'Quantia',
    other: 'Outro',
    success: 'Sucesso',
    error: 'Erro',
    canceled: 'Cancelado',
    pending: 'Pendente',
    processed: 'Processado',
    process_failed: 'Pagamento falhou',
    common__invoice: 'Fatura',
    common__cardholder: 'Titular do cartão',
    common__expiry: 'Expira',
    common__amount_to_pay: 'Quantidade pagável',
    account_number: 'Número da conta de banco',
    accoun_holder: 'Titular da conta bancária',
    bank_name: 'Nome do banco',
    bank_ifsc_code: 'Código IFSC do banco',
    invoice_receipt_number: 'Número do recibo da fatura',
    message: 'Mensagem',
    upi_transaction_id: 'ID da transação UPI',
    bank_transaction_id: 'ID da transação bancária',
    receipt: 'Receipt',
    description: 'Description',

    common__uploader_text: 'Solte o arquivo aqui ou <em>clique para carregar</em>',
    common__files: 'arquivos',
    common__files_size_kb: '{size} kB',
    common__files_size_mb: '{size} mB',

    ...spushMessages.pt,
    ...multiInvoicePageTranslations.pt,
    ...pm.en,
    ...elementUI.pt,
  },

  es: {
    payment_details: 'Requisitos de pago',
    operation_number: 'Número de la operación',
    payment_date: 'Fecha de pago',
    amount: 'Importe',
    success: 'Exitoso',
    error: 'Error',
    canceled: 'Anulado',
    pending: 'En el proceso',
    processed: 'Procesado',
    process_failed: 'No se logró realizar el pago',
    common__amount_to_pay: 'Importe a pagar',

    ...spushMessages.es,
    ...rapipagoMessages.es,
    ...multiInvoicePageTranslations.es,
  },

  // Swahili
  sw: {
    amount: 'Kiasi',
    come_back: 'Nyuma',
    stepper__first__select_method: 'Chagua njia yako ya malipo',
    stepper__second__payment_process: 'Mchakato ya malipo',
    stepper__third__status_page: 'Hali ya malipo',

    ...selcomTranslations.sw,
  },

  uz: {
    common__invoice: 'Invoys',
    common__cardholder: 'Karta egasi',
    common__amount_to_pay: "To'lanishi kerak bo'lgan miqdor",
    common__expiry: 'Expires',
    receipt: 'Kvitansiya',
    description: 'Tavsif',
    common__uploader_text: 'Faylni shu yerga torting yoki <em>yuklash uchun bosing</em>',
    common__files: 'Fayllar',
    common__files_size_kb: '{size} kB',
    common__files_size_mb: '{size} mB',

    ...multiInvoicePageTranslations.uz,
  },

  de: {
    ...spushMessages.de,
  },
  tr: {
    ...spushMessages.tr,
  },
  fr: {
    ...spushMessages.fr,
  },
  it: {
    ...spushMessages.it,
  },

  az: {
    common__invoice: 'Faktura',
    common__amount_to_pay: 'Ödəniləcək məbləğ',
    common__cardholder: 'Kart sahibinin adı',
    common__expiry: 'Bitmə tarixi',
    common__uploader_text: 'Faylı buraya atın və ya <em>yükləmək üçün klikləyin</em>',
    common__files: 'fayllar',
    receipt: 'Qəbz',
    description: 'Təsvir',
    common__files_size_kb: '{size} kB',
    common__files_size_mb: '{size} mB',

    ...multiInvoicePageTranslations.az,
    ...elementUI.az,
  },
};

export default {
  init(locale) {
    const defaultAvailableLocales = ['en', 'ru', 'uk', 'sw'];

    console.log('Presseted', window.location);
    return new VueI18n({
      silentTranslationWarn: true,
      fallbackLocale: 'en',
      locale: defaultAvailableLocales.includes(locale) ? locale : 'en',
      messages,
    });
  },
};
